import { render, staticRenderFns } from "./InquiryTop.vue?vue&type=template&id=3dc79ac8&"
import script from "./InquiryTop.vue?vue&type=script&lang=ts&"
export * from "./InquiryTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports